var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "child" }, [
    _c("div", { staticClass: "child__wrapper" }, [
      _c(
        "div",
        { staticClass: "child__age" },
        [
          _c("c-input", {
            attrs: {
              "floating-label": "Возраст, лет",
              clearable: true,
              type: "price-number",
              "max-length": 2,
              invalid: _vm.error && _vm.error.age,
              error: _vm.error && _vm.error.age,
            },
            model: {
              value: _vm.child.age,
              callback: function ($$v) {
                _vm.$set(_vm.child, "age", $$v)
              },
              expression: "child.age",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "child__gender" },
        [
          _c("div", { staticClass: "c-input-label" }, [_vm._v("Пол")]),
          _c("c-switcher2", {
            staticClass: "h-switcher",
            attrs: {
              type: "group",
              items: [
                { icon: "male", value: "m", tooltip: "Мужской" },
                { icon: "female", value: "f", tooltip: "Женский" },
              ],
            },
            model: {
              value: _vm.child.gender,
              callback: function ($$v) {
                _vm.$set(_vm.child, "gender", $$v)
              },
              expression: "child.gender",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "child__remove" },
        [
          _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Удалить",
                  placement: "top",
                },
                expression:
                  "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                modifiers: { html: true },
              },
            ],
            attrs: { size: "iconic", icon: "trash" },
            on: {
              click: function ($event) {
                return _vm.$emit("remove")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }